import { Link } from "react-router-dom";
import { site } from "../data/site";

// Amenity logo (uploaded). Swap the file in /public/brand to update.
export const Logo = ({ dark = false, className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="site-logo"
      aria-label={`${site.name} — Home`}
      className={`inline-flex items-center ${className}`}
    >
      {dark ? (
        <span className="inline-flex items-center rounded-2xl bg-white px-4 py-3">
          <img
            src="/brand/amenity-logo.webp"
            alt={`${site.name} logo`}
            className="h-14 w-auto"
          />
        </span>
      ) : (
        <img
          src="/brand/amenity-logo-transparent.png"
          alt={`${site.name} logo`}
          className="h-14 sm:h-16 w-auto"
        />
      )}
    </Link>
  );
};
